import {
    AfterContentChecked,
    ChangeDetectionStrategy,
    Component,
    ContentChildren,
    forwardRef,
    inject,
    Inject,
    Input,
    QueryList
} from '@angular/core';
import { TabContentDirective } from '@shared/directives/tab-content';
import { TabsetComponent } from '../tabset';

@Component({
    selector: 'app-tab',
    templateUrl: './tab.component.html',
    styleUrls: ['./tab.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TabComponent implements AfterContentChecked {
    @Input() public title: string;
    @Input() public badgeCount: number;
    @Input() public active: boolean;
    @Input() public disabled = false;
    @Input() public destroyOnHide: boolean;

    @ContentChildren(TabContentDirective, { descendants: false })
    public readonly contentTemplates: QueryList<TabContentDirective>;

    public contentTemplate: TabContentDirective;

    @Inject(forwardRef(() => TabsetComponent)) private readonly tabset: TabsetComponent = inject(TabsetComponent);

    public ngAfterContentChecked() {
        // We are using @ContentChildren instead of @ContentChild as in the Angular version being used
        // only @ContentChildren allows us to specify the {descendants: false} option.
        // Without {descendants: false} we are hitting bugs described in:
        // https://github.com/ng-bootstrap/ng-bootstrap/issues/2240
        this.contentTemplate = this.contentTemplates.first;
    }

    public isPanelInDom() {
        return (this.destroyOnHide ? !this.destroyOnHide : !this.tabset.destroyOnHide) || this.active;
    }
}
